import { render, staticRenderFns } from "./ChatText.vue?vue&type=template&id=182e9662&scoped=true"
import script from "./ChatText.vue?vue&type=script&lang=js"
export * from "./ChatText.vue?vue&type=script&lang=js"
import style0 from "./ChatText.vue?vue&type=style&index=0&id=182e9662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e9662",
  null
  
)

export default component.exports